<template>
  <div class="page-not-found">
    <div class="not-found-container">
      <!-- Background Pattern -->
      <div class="background-pattern">
        <div class="floating-shape shape-1"></div>
        <div class="floating-shape shape-2"></div>
        <div class="floating-shape shape-3"></div>
        <div class="floating-shape shape-4"></div>
      </div>

      <!-- Main Content -->
      <div class="not-found-content">
        <div class="error-illustration">
          <div class="error-number">404</div>
          <div class="error-icon">
            <v-icon size="120" color="primary">mdi-map-marker-question</v-icon>
          </div>
        </div>

        <div class="error-message">
          <h1 class="error-title">{{ $t("text.page-not-found") }}</h1>
          <p class="error-description">
            {{ $t("text.page-not-found-description") }}
          </p>
        </div>

        <div class="error-actions">
          <v-btn @click="goBack" color="primary" size="large" class="action-btn" prepend-icon="mdi-arrow-left">
            {{ $t("text.page-not-found-go-back") }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
  methods: {
    goBack() {
      this.$router.push("/treatments/requests");
    },
  },
};
</script>

<style scoped>
.page-not-found {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.not-found-container {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  width: 100%;
}

.background-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.floating-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 60px;
  height: 60px;
  top: 20%;
  right: 15%;
  animation-delay: 2s;
}

.shape-3 {
  width: 100px;
  height: 100px;
  bottom: 20%;
  left: 15%;
  animation-delay: 4s;
}

.shape-4 {
  width: 40px;
  height: 40px;
  bottom: 10%;
  right: 10%;
  animation-delay: 1s;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }

  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

.not-found-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 60px 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.error-illustration {
  margin-bottom: 40px;
  position: relative;
}

.error-number {
  font-size: 8rem;
  font-weight: 900;
  color: #667eea;
  line-height: 1;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.error-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.3;
}

.error-message {
  margin-bottom: 40px;
}

.error-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px 0;
}

.error-description {
  font-size: 1.1rem;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
  max-width: 500px;
  margin: 0 auto;
}

.error-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.action-btn {
  min-width: 140px;
  border-radius: 12px;
  font-weight: 600;
  text-transform: none;
  height: 48px;
}

.decorative-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: -1;
}

.decoration {
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  animation: float 8s ease-in-out infinite;
}

.decoration-1 {
  top: 15%;
  right: 20%;
  animation-delay: 0s;
}

.decoration-2 {
  top: 60%;
  left: 10%;
  animation-delay: 3s;
}

.decoration-3 {
  bottom: 20%;
  right: 15%;
  animation-delay: 6s;
}

/* Responsive Design */
@media (max-width: 768px) {
  .page-not-found {
    padding: 16px;
  }

  .not-found-content {
    padding: 40px 24px;
  }

  .error-number {
    font-size: 6rem;
  }

  .error-title {
    font-size: 2rem;
  }

  .error-description {
    font-size: 1rem;
  }

  .error-actions {
    flex-direction: column;
    align-items: center;
  }

  .action-btn {
    width: 100%;
    max-width: 280px;
  }
}

@media (max-width: 480px) {
  .error-number {
    font-size: 4rem;
  }

  .error-title {
    font-size: 1.75rem;
  }

  .not-found-content {
    padding: 32px 20px;
  }

  .floating-shape {
    display: none;
  }

  .decoration {
    display: none;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .not-found-content {
    background: rgba(30, 41, 59, 0.95);
  }

  .error-title {
    color: #f1f5f9;
  }

  .error-description {
    color: #94a3b8;
  }
}
</style>